import React, { useState, useEffect, useContext, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios, { fileAxios } from '../../../my-axios';
import UserContext, { getToken } from '../../../contexts/UserContext';
import ContentContext from '../../../contexts/ContentContext';
import { Button, Card, Alert } from 'react-bootstrap';
import { FaCloudArrowUp, FaFile, FaCheck, FaXmark } from 'react-icons/fa6';

//https://www.geeksforgeeks.org/file-uploading-in-react-js/

//post to this url to upload file
const URL = "genieFile/file";
//const appointment_URL = "genieFile/appointmentFile";

export default function GenieFile() {
  const navigate = useNavigate();
  const userCtx = useContext(UserContext);
  const contentCtx = useContext(ContentContext);
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    contentCtx.updatePath([{ title: 'Import Reports -  Patients (Genie) & Appointments (Genie/Charm)', link: '/genieFiles' }]);
  }, []);

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setFile(null);
  };

  const onFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setMessage("");
    setSuccess(false);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
      setMessage("");
      setSuccess(false);
    }
  }, []);

  const onFileUpload = () => {
    if (!file) {
      setMessage("Please choose a file!");
      setSuccess(false);
      return;
    }

    setMessage("Uploading...");
    var formData = new FormData();
    formData.append(file.name, file);

    fileAxios.defaults.headers.common['Authorization'] = `Bearer ${userCtx.getToken()}`;

    fileAxios.post(URL, formData)
      .then((result) => {
        if (result.status === 200) {
          setMessage("Successfully uploaded " + result.data.message);
          setSuccess(true);
          resetFileInput();
        }
      })
      .catch((error) => {
        setMessage(error.response?.data?.message || "Upload failed");
        setSuccess(false);
      });
  };

  return (
    <div style={{ display: 'flex'}}>
      <Card className="shadow-sm" style={ { width: '50%' }}>
        <Card.Body>
          <div
            className={`upload-zone p-4 text-center ${isDragging ? 'dragging' : ''}`}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            style={{
              border: '2px dashed #ccc',
              borderRadius: '18px',
              backgroundColor: isDragging ? '#f8f9fa' : 'white',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
          >
            <FaCloudArrowUp
              size={48}
              className="mb-2"
              style={{ color: '#6c757d' }}
            />
            <h5 className="mb-2">Drag & Drop File Here</h5>
            <p className="text-muted mb-2">or</p>
            <div className="d-flex justify-content-center">
              <label className="btn btn-outline-primary mb-0">
                <span>Browse File</span>
                <input
                  ref={fileInputRef}
                  type="file"
                  onChange={onFileChange}
                  style={{ display: 'none' }}
                  accept=".xls,.xlsx"
                />
              </label>
            </div>
            <div className="mt-3 text-muted">
              <small>Supported formats: .xls, .xlsx</small>
            </div>
          </div>

          {file && (
            <div className="selected-files mt-4">
              <h6 className="mb-3">Selected File:</h6>
              <div className="d-flex align-items-center mb-2">
                <FaFile className="mr-1" style={{ color: '#6c757d' }} />
                <span>{file.name}</span>
              </div>
              <div className="mt-3">
                <Button
                  variant="primary"
                  onClick={onFileUpload}
                  className="d-flex align-items-center mx-auto"
                >
                  <FaCloudArrowUp className="mr-1" />
                  Upload File
                </Button>
              </div>
            </div>
          )}

          {message && message !== "Uploading..." && (
            <Alert
              variant={success ? "success" : "danger"}
              className="mt-4 d-flex align-items-center"
            >
              {success ? (
                <FaCheck className="mr-1" />
              ) : (
                <FaXmark className="mr-1" />
              )}
              {message}
            </Alert>
          )}
        </Card.Body>
        <style jsx>{`
        .upload-zone:hover {
          border-color: #007bff;
        }
        .upload-zone.dragging {
          border-color: #007bff;
          background-color: #f8f9fa !important;
        }
        .selected-files {
          max-height: 200px;
          overflow-y: auto;
        }
      `}</style>
      </Card>
    </div>
  );
}
